
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace-management/user-management",
      function () {
        return require("private-next-pages/workspace-management/user-management.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workspace-management/user-management"])
      });
    }
  